export const generalMuiForm = {
    '& .MuiInputBase-root': {
        borderRadius: '123px',
        backgroundColor: 'white',
        '& .MuiInputBase-input': {
            color: '#003670',
            '& label': {
                display: 'none',
            },
        },
        '& input': {
            color: '#3998e9',
            '&::placeholder': {
                color: 'black',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 'normal',
                letterSpacing: 'normal',
                fontFamily: 'Roboto',
            },
        },
    },
    '& .MuiInputBase-root.Mui-disabled': {
        opacity: 0.65,
    },
    '& .MuiFormLabel-root.Mui-disabled': {
        color: '#868686',
    },
    '& .MuiOutlinedInput-root.Mui-disabled': {
        '& .MuiInputBase-input': {
            color: '#868686',
            cursor: 'not-allowed',
        },
        '&:hover fieldset': {
            borderColor: 'rgba(0, 0, 0, 0.26)',
        },
    },
    '& .MuiFormLabel-root': {
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'left',
    },
    '& .MuiOutlinedInput-root.Mui-error': {
        '&:hover fieldset': {
            borderColor: '#f44336',
        },
        '& .MuiInputBase-input': {
            color: '#f44336',
        }
    },
    '& .MuiSelect-root': {
        borderRadius: '123px',
        backgroundColor: 'white',
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            border: 'solid 1px #e2e3eb',
        },
        '&:hover fieldset': {
            borderColor: '#3998e9',
        },
    },
};
